document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('f-p-checkbox');
  if (!checkbox) return;
  const wrapper = checkbox.closest('.f-p-add-to-cart-wrapper');
  const variantId = checkbox.dataset.variantId;
  const cartUrl = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
  const error = document.getElementById('StellarCartOptionError');
  let busy = false;
  const notify = () => document.dispatchEvent(new CustomEvent('stellar:cart-state'));
  let cartRevision = 0;
  const syncOption = cart => { checkbox.checked = cart.items.some(item => String(item.variant_id) === String(variantId)); };
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
    const revision = ++cartRevision;
    if (busy) return;
    if (Array.isArray(event.cartData?.items)) { syncOption(event.cartData); return; }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`${cartUrl}.js`, { signal: controller.signal, cache: 'no-store' });
      const cart = await response.json();
      if (response.ok && !controller.signal.aborted && !busy && revision === cartRevision && Array.isArray(cart.items)) syncOption(cart);
    } catch (_) {} finally { clearTimeout(timer); }
  });
  async function refreshCart() {
    const response = await fetch(cartUrl);
    if (!response.ok) throw new Error('refresh');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    for (const selector of ['cart-items', '#main-cart-footer .js-contents', '#StellarCartRecommendations']) {
      const current = document.querySelector(selector); const updated = doc.querySelector(selector);
      if (current && updated) current.innerHTML = updated.innerHTML;
    }
    const isEmpty = doc.querySelector('cart-items')?.classList.contains('is-empty') || false;
    document.querySelector('cart-items')?.classList.toggle('is-empty', isEmpty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
    const updatedOption = doc.getElementById('f-p-checkbox');
    if (updatedOption) checkbox.checked = updatedOption.checked;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
  }
  checkbox.addEventListener('change', async () => {
    if (busy) return;
    const requested = checkbox.checked; ++cartRevision; busy = true; checkbox.disabled = true; wrapper.classList.add('active');
    if (error) { error.hidden = true; error.textContent = ''; } notify();
    try {
      const currentResponse = await fetch(`${cartUrl}.js`);
      if (!currentResponse.ok) throw new Error('cart');
      const cart = await currentResponse.json();
      const existing = cart.items.filter(item => String(item.variant_id) === String(variantId));
      if (requested && !existing.length) {
        const response = await fetch(window.routes?.cart_add_url || `${cartUrl}/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const result = await response.json(); if (!response.ok || result.status) throw new Error(result.description || result.message);
      } else if (!requested && existing.length) {
        const updates = Object.fromEntries(existing.map(item => [item.key, 0]));
        const response = await fetch(window.routes?.cart_update_url || `${cartUrl}/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ updates })
        });
        const result = await response.json(); if (!response.ok || result.status) throw new Error(result.description || result.message);
      }
      await refreshCart();
    } catch {
      try {
        const response = await fetch(`${cartUrl}.js`);
        if (response.ok) { const cart = await response.json(); checkbox.checked = cart.items.some(item => String(item.variant_id) === String(variantId)); }
      } catch { checkbox.checked = !requested; }
      if (error) { error.textContent = window.stellarStrings?.cartOptionError || ''; error.hidden = false; }
    } finally {
      busy = false; checkbox.disabled = false; wrapper.classList.remove('active'); notify();
    }
  });
});
